import BaseDataGrid from 'base-components/BaseDataGrid/BaseDataGrid';
import Filter from 'models/api/filter';
import DataGridProp from 'models/dataGridProp';
import Id from 'models/id';
import { useWorkplaceState } from 'providers/WorkplaceStateProvider';
import { PropsWithChildren } from 'react';
import { RowHeightArgs } from 'react-data-grid';
import './Workplace.scss';
import { TableData } from 'providers/WorkplaceStateProvider';

type WorkplaceTableProps<TableType, FilterType> = PropsWithChildren<{
    lineHeight?: number | ((args: RowHeightArgs<TableType>) => number);
    rowClass?: (row: TableType) => string | undefined;
    clickable: boolean;
    showSummaryRows?: true;
    groupBy?: string[] | undefined;
    rowGrouper?: (
        rows: readonly TableType[],
        columnKey: string
    ) => Record<string, readonly TableType[]>;
    expandedGroupIds?: ReadonlySet<unknown>;
    onExpandedGroupIdsChange?: (expandedGroupIds: Set<unknown>) => void;
    tableData: TableData<any>,
    filter: FilterType,
    tableLoading: boolean,
}>;

export default function WorkplaceTable<
    TableType extends DataGridProp,
    ItemType extends Id = TableType,
    FilterType extends Filter = Filter<TableType>,
    ChangeRequestType = ItemType,
    AddRequestType = ItemType,
>({
    lineHeight,
    rowClass,
    clickable,
    showSummaryRows,
    groupBy,
    rowGrouper,
    expandedGroupIds,
    onExpandedGroupIdsChange,
    children,
    tableData,
    filter,
    tableLoading,
}: WorkplaceTableProps<TableType, FilterType>) {
    const { setTableData, loading } =
        useWorkplaceState<TableType, ItemType, ChangeRequestType, AddRequestType>();

    return (
        <BaseDataGrid<TableType, TableType[]>
            reactDataGreedProps={{
                defaultColumnOptions: {
                    sortable: false,
                    resizable: true,
                },
                rowClass: rowClass,
                summaryRows: showSummaryRows && [tableData.data],
                groupBy: groupBy,
                rowGrouper: rowGrouper,
                expandedGroupIds: expandedGroupIds,
                onExpandedGroupIdsChange: onExpandedGroupIdsChange,
            }}
            rows={tableData.data}
            lineHeight={lineHeight}
            loading={loading || tableLoading}
            clickable={clickable}
            setTableData={setTableData}
            orderColumn={filter.orderColumn}
            orderDesc={filter.orderDesc}
        >
            {children}
        </BaseDataGrid>
    );
}
